import Dropdown from "stimulus-dropdown";
Stimulus.register("dropdown", Dropdown);
